import React from 'react';
import {connect} from 'react-redux';

// Components
import Anchor from 'Components/common/Anchor';
import BasicButton from 'Components/common/BasicButton';
import Dialog from 'Components/common/Dialog';
import ProductImage from 'Components/commonOrder/ProductImage';
import ShowShippingPlanModal from 'Components/host/showShippingPlanModal';
import util from 'Utils/commonUtil';

// Actions
import {openNotification} from 'Actions/notification';
import {
    queryPickOrderList,
    cancelPickOrder,
    shipOrder,
    createInvoiceMorePdf,
    previewBatchShipmentPdf,
    batchRecommendProductPdf,
    batchPickOrderPreviewPdf,
    getPickOrderMessageList,
    oneKeyReadMessage,
} from 'Actions/host';
import {completeShippingPlan} from 'Actions/myOrder';

import {
    batchRecommendPdfsUrl,
    pickOrderPreviewPdfsUrl,
    printDispatchPdfsUrl,
} from 'Utils/urlUtil';

// Icons
import {
    ArrowBackIos,
    ExpandLess,
    ExpandMore,
    Message,
} from '@material-ui/icons';
import {Checkbox} from '@material-ui/core';
import {T} from 'Actions/translate';

class MyOrderPick extends React.Component {
    state = {
        orderDetails: {},
        products: {},
        isShowPrice: true,
        expressNumber: '',
        submitBtnLoaded: true,
        f1OrderShipData: [],
        confirmShipData: [],
        shipExitOpened: false,
        disabledSubmitBtn: true,
        confirmShipmentDialogOpened: false,
        shipmentCount: 0,
        checkAll: false,
        pickOrderList: [],
        allExpandLess: false,
        confirmCancelPickOrderDialog: false,
        confirmBatchShipmentOrderDialog: false,
        confirmRecommendedProductDialog: false,
        confirmPickOrderPreviewDialog: false,
        currentOrderIdMessageList: [],
        orderMessageListDialog: false,
        currentEoneNum: 0,
        currentOrderId: 0,
        currentCheckoutPickOrder: [],
        completedShippingPlanDialog: false,
        currentPlanId: 0,
    };

    componentWillMount() {
        this.getPickOrderList();
    }

    getPickOrderList = () => {
        let params = {};
        this.props.queryPickOrderList(params).then((res) => {
            if (res) {
                if (res.status === 'success') {
                    if (res.data.length > 0) {
                        res.data.forEach((item) => {
                            item.pickOrderVO.checked = false;
                            item.pickOrderVO.expandValue = true;
                        });

                        this.state.currentCheckoutPickOrder.forEach(
                            (checkId) => {
                                res.data.forEach((data) => {
                                    if (checkId === data.pickOrderVO.id) {
                                        data.pickOrderVO.checked = true;
                                    }
                                });
                            },
                        );
                    }
                    this.setState({
                        pickOrderList: res.data,
                        currentCheckoutPickOrder: [],
                    });
                }
            }
        });
    };

    goBack = () => {
        const {orderDetails} = this.state;

        if (orderDetails.status === 2) {
            this.props.history.replace('/shipmentList/onHold');
        } else {
            this.props.history.replace('/shipmentList/toBeShip');
        }
    };

    goMyOrderPick = () => {
        this.props.history.push(`/myOrderPick`);
        if (this.state.confirmRecommendedProductDialog) {
            this.setState({
                confirmRecommendedProductDialog: false,
            });
        }

        if (this.state.confirmPickOrderPreviewDialog) {
            this.setState({
                confirmPickOrderPreviewDialog: false,
            });
        }

        if (this.state.confirmBatchShipmentOrderDialog) {
            this.setState({
                confirmBatchShipmentOrderDialog: false,
            });
        }
    };

    singleHandleCheck = (index, event) => {
        let currentPickOrderList = JSON.parse(
            JSON.stringify(this.state.pickOrderList),
        );
        currentPickOrderList.length > 0 &&
            currentPickOrderList.map((pickItem) => {
                if (pickItem.pickOrderVO.id === index) {
                    if (event.target.checked) {
                        pickItem.pickOrderVO.checked = true;
                    } else {
                        pickItem.pickOrderVO.checked = false;
                    }
                }
            });
        this.setState({
            pickOrderList: currentPickOrderList,
        });
    };

    expandLessLotHandle = (eoneNumber, pickOrderId, expandValue) => {
        this.setExpandValue(pickOrderId, expandValue);
    };

    setExpandValue = (pickOrderId, expandValue) => {
        let currentPickOrderList = JSON.parse(
            JSON.stringify(this.state.pickOrderList),
        );
        currentPickOrderList.length > 0 &&
            currentPickOrderList.map((pickItem) => {
                if (pickItem.pickOrderVO.id === pickOrderId) {
                    pickItem.pickOrderVO.expandValue = !expandValue;
                }
            });

        let currentTrueCount = 0;
        let currentFalseCount = 0;
        currentPickOrderList.length > 0 &&
            currentPickOrderList.map((item) => {
                if (item.pickOrderVO.expandValue) {
                    ++currentTrueCount;
                }

                if (!item.pickOrderVO.expandValue) {
                    ++currentFalseCount;
                }
            });
        if (currentTrueCount === currentPickOrderList.length) {
            this.setState({
                pickOrderList: currentPickOrderList,
                allExpandLess: false,
            });
        } else if (currentFalseCount === currentPickOrderList.length) {
            this.setState({
                pickOrderList: currentPickOrderList,
                allExpandLess: true,
            });
        } else {
            this.setState({
                pickOrderList: currentPickOrderList,
            });
        }
    };

    allExpandOrLessLotHandle = () => {
        const {allExpandLess, pickOrderList} = this.state;
        let currentPickOrderList = JSON.parse(JSON.stringify(pickOrderList));
        let currentAllStatus = allExpandLess;
        if (allExpandLess) {
            currentPickOrderList.length > 0 &&
                currentPickOrderList.forEach((currentPickItem) => {
                    currentPickItem.pickOrderVO.expandValue = true;
                });
            currentAllStatus = false;
        } else {
            currentPickOrderList.length > 0 &&
                currentPickOrderList.forEach((currentPickItem) => {
                    currentPickItem.pickOrderVO.expandValue = false;
                });
            currentAllStatus = true;
        }
        this.setState({
            pickOrderList: currentPickOrderList,
            allExpandLess: currentAllStatus,
        });
    };

    handleAllCheck = (event) => {
        let currentPickOrderList = JSON.parse(
            JSON.stringify(this.state.pickOrderList),
        );
        currentPickOrderList.length > 0 &&
            currentPickOrderList.forEach((currentPickItem) => {
                currentPickItem.pickOrderVO.checked = event.target.checked;
            });
        this.setState({
            checkAll: event.target.checked,
            pickOrderList: currentPickOrderList,
        });
    };

    deliverInfor = () => {};

    deletePickOrdersHandle = () => {
        let pickIds = this.getPickIds();
        if (pickIds.length > 0) {
            this.setState({
                confirmCancelPickOrderDialog: true,
            });
        } else {
            this.props.openNotification(
                T('shipment_pick_please_select_pick_order'),
                'danger',
            );
        }
    };

    recommendedProductHandle = () => {
        let pickIds = this.getPickIds();
        if (pickIds.length > 0) {
            this.setState({
                confirmRecommendedProductDialog: true,
            });
        } else {
            this.props.openNotification(
                T('shipment_pick_please_select_recommended_product'),
                'danger',
            );
        }
    };

    confirmBatchRecommendedProductHandle = () => {
        let orderIds = this.getOrderIds();
        if (util.isIOS()) {
            window.location.href =
                window.location.origin +
                '/pdf-preview/pdf-preview-pick-order.html?url=' +
                window.location.origin +
                batchRecommendPdfsUrl +
                '?orderIds=' +
                orderIds;
        } else {
            if (util.isWechatBrowser()) {
                window.location.href =
                    window.location.origin +
                    '/pdf-preview/pdf-preview-pick-order.html?url=' +
                    window.location.origin +
                    batchRecommendPdfsUrl +
                    '?orderIds=' +
                    orderIds;
            } else {
                window.open(
                    window.location.origin +
                        '/pdf-preview/pdf-preview-pick-order.html?url=' +
                        window.location.origin +
                        batchRecommendPdfsUrl +
                        '?orderIds=' +
                        orderIds,
                    '_blank',
                );
                this.goMyOrderPick();
            }
        }
    };

    pickOrderPreviewHandle = () => {
        let pickIds = this.getPickIds();
        if (pickIds.length > 0) {
            this.setState({
                confirmPickOrderPreviewDialog: true,
            });
        } else {
            this.props.openNotification(
                T('shipment_pick_please_select_pick_order'),
                'danger',
            );
        }
    };

    confirmBatchPrintPickOrderHandle = () => {
        let pickIds = this.getPickIds();
        if (util.isIOS()) {
            window.location.href =
                window.location.origin +
                '/pdf-preview/pdf-preview-pick-order.html?url=' +
                window.location.origin +
                pickOrderPreviewPdfsUrl +
                '?ids=' +
                pickIds;
        } else {
            if (util.isWechatBrowser()) {
                window.location.href =
                    window.location.origin +
                    '/pdf-preview/pdf-preview-pick-order.html?url=' +
                    window.location.origin +
                    pickOrderPreviewPdfsUrl +
                    '?ids=' +
                    pickIds;
            } else {
                window.open(
                    window.location.origin +
                        '/pdf-preview/pdf-preview-pick-order.html?url=' +
                        window.location.origin +
                        pickOrderPreviewPdfsUrl +
                        '?ids=' +
                        pickIds,
                    '_blank',
                );
                this.goMyOrderPick();
            }
        }
    };

    getOrderIds = () => {
        let orderIds = [];
        let currentPickOrderList = JSON.parse(
            JSON.stringify(this.state.pickOrderList),
        );
        currentPickOrderList.length > 0 &&
            currentPickOrderList.forEach((currentPickItem) => {
                if (currentPickItem.pickOrderVO.checked) {
                    orderIds.push(currentPickItem.pickOrderVO.orderId);
                }
            });
        return orderIds;
    };

    checkUnreadMessage = () => {
        let isUnreadMessageFlag = false;
        let currentPickOrderList = JSON.parse(
            JSON.stringify(this.state.pickOrderList),
        );
        currentPickOrderList.length > 0 &&
            currentPickOrderList.forEach((currentPickItem) => {
                if (
                    currentPickItem.pickOrderVO.checked &&
                    currentPickItem.pickOrderVO.unReadCount > 0
                ) {
                    isUnreadMessageFlag = true;
                }
            });
        return isUnreadMessageFlag;
    };

    shipOrderHandle = () => {
        let pickIds = this.getPickIds();
        if (pickIds.length > 0) {
            if (this.checkUnreadMessage()) {
                this.props.openNotification(
                    T('shipment_pick_you_have_unread_message_please_read'),
                    'danger',
                );
            } else {
                this.setState({
                    confirmBatchShipmentOrderDialog: true,
                });
            }
        } else {
            this.props.openNotification(
                T('shipment_pick_please_select_shipment_pick_order'),
                'danger',
            );
        }
    };

    confirmBatchShipmentOrderHandle = () => {
        let pickIds = this.getPickIds();
        this.props
            .shipOrder({ids: pickIds})
            .then((res) => {
                if (res.data.length > 0) {
                    if (util.isIOS()) {
                        window.location.href =
                            window.location.origin +
                            '/pdf-preview/pdf-preview-pick-order.html?url=' +
                            window.location.origin +
                            printDispatchPdfsUrl +
                            '?shipmentIds=' +
                            res.data;
                    } else {
                        if (util.isWechatBrowser()) {
                            window.location.href =
                                window.location.origin +
                                '/pdf-preview/pdf-preview-pick-order.html?url=' +
                                window.location.origin +
                                printDispatchPdfsUrl +
                                '?shipmentIds=' +
                                res.data;
                        } else {
                            window.open(
                                window.location.origin +
                                    '/pdf-preview/pdf-preview-pick-order.html?url=' +
                                    window.location.origin +
                                    printDispatchPdfsUrl +
                                    '?shipmentIds=' +
                                    res.data,
                                '_blank',
                            );
                            this.goMyOrderPick();
                        }
                    }
                }
            })
            .catch((res) => {
                if (res && res.status === 'has_unread_message') {
                    this.props.openNotification(
                        T('shipment_pick_order_has_unread_message'),
                        'danger',
                    );
                } else if (res && res.status === 'shortage_of_stock') {
                    this.props.openNotification(
                        T(
                            'shipment_pick_order_inventory_less_than_quantity_shipped',
                        ),
                        'danger',
                    );
                } else if (res && res.status === 'quantity_incorrect') {
                    this.props.openNotification(
                        T('notification_delivery_quantity_error'),
                        'danger',
                    );
                }
                this.setState({
                    confirmBatchShipmentOrderDialog: false,
                });
            });
    };

    cancelPickOrderHandle = () => {
        let pickIds = this.getPickIds();
        this.props.cancelPickOrder({ids: pickIds}).then((res) => {
            if (res && res.status === 'success') {
                this.getPickOrderList(); //删除成功，刷新拣货单
                this.props.openNotification(
                    T('shipment_pick_delete_pick_order_success'),
                    'success',
                );
                this.setState({
                    confirmCancelPickOrderDialog: false,
                    allExpandLess: false,
                });
            }
        });
    };

    getPickIds = () => {
        let pickIds = [];
        let currentPickOrderList = JSON.parse(
            JSON.stringify(this.state.pickOrderList),
        );
        currentPickOrderList.length > 0 &&
            currentPickOrderList.forEach((currentPickItem) => {
                if (currentPickItem.pickOrderVO.checked) {
                    pickIds.push(currentPickItem.pickOrderVO.id);
                }
            });
        return pickIds;
    };

    readPickOrderMessageHandle = (orderId, eoneNumber) => {
        let checkoutPickOrder = this.getPickIds();
        this.props.getPickOrderMessageList({id: orderId}).then((res) => {
            if (res && res.status === 'success') {
                if (res.data.length > 0) {
                    this.setState({
                        currentOrderIdMessageList: res.data,
                        orderMessageListDialog: true,
                        currentEoneNum: eoneNumber,
                        currentOrderId: orderId,
                        currentCheckoutPickOrder: checkoutPickOrder,
                    });
                }
            }
        });
    };

    onKeyReadMessageHandle = () => {
        this.props
            .oneKeyReadMessage({
                messageKey: this.state.currentEoneNum,
                messageMode: 'ORDER',
            })
            .then((res) => {
                this.getPickOrderList();
                this.setState({
                    currentOrderIdMessageList: [],
                    orderMessageListDialog: false,
                    currentEoneNum: 0,
                    currentOrderId: 0,
                    allExpandLess: false,
                });
            });
    };

    dialogDidClose = (dialog) => {
        if (dialog === 'completedShippingPlanDialog') {
            this.clearPlanId();
        }
        this.state[dialog] && this.setState({[dialog]: false});
    };

    completedShippingPlanHandle = (planId) => {
        this.setState({
            completedShippingPlanDialog: true,
            currentPlanId: planId,
        });
    };

    markAsComplete = () => {
        const {currentPlanId, pickOrderList} = this.state;

        let currentPickOrderList = JSON.parse(JSON.stringify(pickOrderList));
        if (currentPickOrderList && currentPickOrderList.length > 0) {
            currentPickOrderList.map((pickOrder) => {
                if (
                    pickOrder.pickOrderDetailVOList &&
                    pickOrder.pickOrderDetailVOList.length > 0
                ) {
                    pickOrder.pickOrderDetailVOList.map(
                        (pickOrderDetailItem) => {
                            if (
                                pickOrderDetailItem.shippingPlan &&
                                pickOrderDetailItem.shippingPlan.length > 0
                            ) {
                                pickOrderDetailItem.shippingPlan.map(
                                    (shippingPlanItem) => {
                                        if (
                                            currentPlanId &&
                                            currentPlanId ===
                                                shippingPlanItem.id
                                        ) {
                                            shippingPlanItem.markComplete = true;
                                        }
                                    },
                                );
                            }
                        },
                    );
                }
            });
        }
        this.setState({
            pickOrderList: currentPickOrderList,
        });
    };

    completedShippingPlanEvent = () => {
        const {currentPlanId} = this.state;

        this.markAsComplete();
        this.props.completeShippingPlan({planId: currentPlanId}).then((res) => {
            if (res && res.status === 'success') {
                this.setState(
                    {
                        completedShippingPlanDialog: false,
                    },
                    () => {
                        this.clearPlanId();
                    },
                );
            }
        });
    };

    clearPlanId = () => {
        this.setState({
            currentPlanId: 0,
        });
    };

    render() {
        const {
            pickOrderList,
            allExpandLess,
            checkAll,
            confirmCancelPickOrderDialog,
            confirmBatchShipmentOrderDialog,
            confirmRecommendedProductDialog,
            confirmPickOrderPreviewDialog,
            orderMessageListDialog,
            currentOrderIdMessageList,
            currentOrderId,
            currentEoneNum,
            completedShippingPlanDialog,
        } = this.state;
        return (
            <div className="my-order-pick-container">
                <div className="header-wrap">
                    <div className="my-order-pick-header container-max-width is-fixed">
                        <Anchor
                            className="go-back"
                            onClickOfSingleTap={this.goBack}>
                            <ArrowBackIos />
                        </Anchor>
                        {T('shipment_pick_list')}
                        <div
                            className="all-expand-area"
                            onClick={() => this.allExpandOrLessLotHandle()}>
                            {allExpandLess
                                ? T('shipment_pick_all_expand_more')
                                : T('shipment_pick_all_expand_less')}
                        </div>
                    </div>
                </div>
                <ul className="order-pick-list">
                    {pickOrderList.length > 0 &&
                        pickOrderList.map((pickOrderItem) => (
                            <li
                                key={pickOrderItem.pickOrderVO.id}
                                className="order-pick-item">
                                <div>
                                    <div className="order-pick-title">
                                        <div className="title-left">
                                            <div className="checkbox">
                                                <Checkbox
                                                    checked={
                                                        pickOrderItem
                                                            .pickOrderVO.checked
                                                    }
                                                    onChange={this.singleHandleCheck.bind(
                                                        this,
                                                        pickOrderItem
                                                            .pickOrderVO.id,
                                                    )}
                                                />
                                            </div>
                                            {pickOrderItem.pickOrderVO &&
                                                pickOrderItem.pickOrderVO
                                                    .stAlphaName}
                                        </div>
                                        {pickOrderItem.pickOrderVO &&
                                        pickOrderItem.pickOrderVO
                                            .messageCount ? (
                                            <div className="title-right">
                                                {pickOrderItem.pickOrderVO &&
                                                pickOrderItem.pickOrderVO
                                                    .unReadCount > 0 ? (
                                                    <img
                                                        src={
                                                            new URL(
                                                                'Images/unread_message.svg',
                                                                import.meta.url,
                                                            ).href
                                                        }
                                                        alt=""
                                                        onClick={() =>
                                                            this.readPickOrderMessageHandle(
                                                                pickOrderItem
                                                                    .pickOrderVO
                                                                    .orderId,
                                                                pickOrderItem
                                                                    .pickOrderVO
                                                                    .eoneNumber,
                                                            )
                                                        }
                                                    />
                                                ) : (
                                                    <img
                                                        src={
                                                            new URL(
                                                                'Images/read_message.svg',
                                                                import.meta.url,
                                                            ).href
                                                        }
                                                        alt=""
                                                        onClick={() =>
                                                            this.readPickOrderMessageHandle(
                                                                pickOrderItem
                                                                    .pickOrderVO
                                                                    .orderId,
                                                                pickOrderItem
                                                                    .pickOrderVO
                                                                    .eoneNumber,
                                                            )
                                                        }
                                                    />
                                                )}
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className="order-pick-infor">
                                        <div className="first-row">
                                            <div className="first-colomn">
                                                <label className="receiver-label">
                                                    {T('shippment_receiver')}:
                                                </label>
                                                <div className="receiver-value">
                                                    {pickOrderItem.pickOrderVO &&
                                                        pickOrderItem
                                                            .pickOrderVO
                                                            .receiver}
                                                </div>
                                            </div>
                                            <div className="second-colomn">
                                                <label className="receiver-tel-label">
                                                    {T('shippment_contact')}:
                                                </label>
                                                <div className="receiver-tel-value">
                                                    {pickOrderItem.pickOrderVO &&
                                                        pickOrderItem
                                                            .pickOrderVO
                                                            .receiverTel}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="second-row">
                                            <div className="first-colomn">
                                                <label className="eone-num-label">
                                                    {T('order_eone_number')}:
                                                </label>
                                                <div className="eone-num-value">
                                                    {pickOrderItem.pickOrderVO &&
                                                        pickOrderItem
                                                            .pickOrderVO
                                                            .eoneNumber}
                                                </div>
                                            </div>
                                            <div className="second-colomn">
                                                <label className="remark-label">
                                                    {T('order_purchase_date')}:
                                                </label>
                                                <div className="remark-value">
                                                    {pickOrderItem.pickOrderVO
                                                        .orderCreateTime &&
                                                        pickOrderItem
                                                            .pickOrderVO
                                                            .orderCreateTime}
                                                </div>
                                            </div>
                                        </div>
                                        {pickOrderItem.pickOrderVO &&
                                        pickOrderItem.pickOrderVO.remark ? (
                                            <div className="third-row">
                                                <label>
                                                    {T('shippment_remark')}:
                                                </label>
                                                <div className="remark-value">
                                                    {
                                                        pickOrderItem
                                                            .pickOrderVO.remark
                                                    }
                                                </div>
                                            </div>
                                        ) : null}
                                    </div>
                                    {pickOrderItem.pickOrderDetailVOList.map(
                                        (pickKitItem) =>
                                            pickOrderItem.pickOrderVO
                                                .expandValue ? (
                                                <div
                                                    className="order-pick-kit-info"
                                                    id={
                                                        'kit-' +
                                                        pickOrderItem
                                                            .pickOrderVO
                                                            .eoneNumber +
                                                        '-' +
                                                        pickOrderItem
                                                            .pickOrderVO.id
                                                    }>
                                                    <div className="first-row-container">
                                                        <div className="first-column-container">
                                                            <div className="image-box">
                                                                <ProductImage
                                                                    src={
                                                                        pickKitItem.pickOrderKit &&
                                                                        pickKitItem
                                                                            .pickOrderKit
                                                                            .productPic
                                                                    }
                                                                    alt={
                                                                        pickKitItem.pickOrderKit &&
                                                                        pickKitItem
                                                                            .pickOrderKit
                                                                            .productName
                                                                    }
                                                                    key={
                                                                        pickKitItem.pickOrderKit &&
                                                                        pickKitItem
                                                                            .pickOrderKit
                                                                            .productPic
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="item-info">
                                                            <div className="item-name">
                                                                <div className="pick-kit-row">
                                                                    {pickKitItem.pickOrderKit &&
                                                                        pickKitItem
                                                                            .pickOrderKit
                                                                            .kit}
                                                                </div>
                                                                <div className="parent-specifications">
                                                                    {pickKitItem.pickOrderKit &&
                                                                        pickKitItem
                                                                            .pickOrderKit
                                                                            .specifications}
                                                                </div>
                                                            </div>
                                                            <div className="first-row">
                                                                <div className="first-column">
                                                                    {T(
                                                                        'storeCondition',
                                                                    )}
                                                                    :{' '}
                                                                    {pickKitItem.pickOrderKit &&
                                                                        pickKitItem
                                                                            .pickOrderKit
                                                                            .storeCondition}
                                                                </div>
                                                                <div className="second-column">
                                                                    {T(
                                                                        'fone_order_shipping_condition',
                                                                    )}
                                                                    :{' '}
                                                                    {pickKitItem.pickOrderKit &&
                                                                        pickKitItem
                                                                            .pickOrderKit
                                                                            .shippingCondition}
                                                                </div>
                                                            </div>
                                                            <div className="second-row">
                                                                <div className="first-colomn">
                                                                    <label>
                                                                        {T(
                                                                            'shipment_pick_not_shippment_quantity_colon',
                                                                        )}
                                                                        :
                                                                    </label>
                                                                    {pickKitItem.pickOrderKit &&
                                                                        pickKitItem
                                                                            .pickOrderKit
                                                                            .tobeShippedQuantity}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <ShowShippingPlanModal
                                                        item={pickKitItem}
                                                        completedShippingPlanHandle={
                                                            this
                                                                .completedShippingPlanHandle
                                                        }
                                                    />

                                                    <div className="order-pick-sku-infor">
                                                        <ui className="order-pick-sku-container">
                                                            {pickKitItem
                                                                .pickOrderComponentList
                                                                .length > 0 &&
                                                                pickKitItem.pickOrderComponentList.map(
                                                                    (
                                                                        pickOrderComponent,
                                                                    ) => (
                                                                        <li className="order-pick-sku-li">
                                                                            {pickKitItem
                                                                                .pickOrderKit
                                                                                .kitFlag ? (
                                                                                <div className="order-pick-sku-title">
                                                                                    <div className="pick-sku-value">
                                                                                        {pickOrderComponent &&
                                                                                            pickOrderComponent.sku}
                                                                                    </div>
                                                                                    <div className="first-row">
                                                                                        <div className="first-column">
                                                                                            <label>
                                                                                                {T(
                                                                                                    'host_advent_product_specifications',
                                                                                                )}
                                                                                            </label>
                                                                                            {pickOrderComponent &&
                                                                                                pickOrderComponent.specifications}
                                                                                        </div>
                                                                                        <div className="second-column">
                                                                                            <label>
                                                                                                {T(
                                                                                                    'shipment_pick_not_shippment_quantity_colon',
                                                                                                )}

                                                                                                :
                                                                                            </label>
                                                                                            {pickOrderComponent &&
                                                                                                pickOrderComponent.tobeShippedQuantity}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="second-row">
                                                                                        <div className="first-column">
                                                                                            <label>
                                                                                                {T(
                                                                                                    'storeCondition',
                                                                                                )}

                                                                                                :
                                                                                            </label>
                                                                                            {pickOrderComponent &&
                                                                                                pickOrderComponent.storeCondition}
                                                                                        </div>
                                                                                        <div className="second-column">
                                                                                            <label>
                                                                                                {T(
                                                                                                    'fone_order_shipping_condition',
                                                                                                )}

                                                                                                :
                                                                                            </label>
                                                                                            {pickOrderComponent &&
                                                                                                pickOrderComponent.shippingCondition}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            ) : null}
                                                                            <div className="order-pick-lot-container">
                                                                                <ul className="order-pick-lot-ul">
                                                                                    {pickOrderComponent &&
                                                                                        pickOrderComponent.lotDnsaList &&
                                                                                        pickOrderComponent
                                                                                            .lotDnsaList
                                                                                            .length &&
                                                                                        pickOrderComponent.lotDnsaList.map(
                                                                                            (
                                                                                                pickLogItem,
                                                                                            ) => (
                                                                                                <li className="order-pick-lot-li">
                                                                                                    <div className="first-row">
                                                                                                        <div className="first-column item-area">
                                                                                                            {T(
                                                                                                                'host_advent_products_item',
                                                                                                            )}
                                                                                                            {pickLogItem &&
                                                                                                                pickLogItem.sku}
                                                                                                        </div>
                                                                                                        <div className="second-column">
                                                                                                            <label>
                                                                                                                {T(
                                                                                                                    'shippment_details_shippment_quantity',
                                                                                                                )}

                                                                                                                :
                                                                                                            </label>
                                                                                                            <div className="pick-lot-quantity">
                                                                                                                {pickLogItem &&
                                                                                                                    pickLogItem.quantity}
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="second-row">
                                                                                                        <div className="first-column">
                                                                                                            <label>
                                                                                                                {T(
                                                                                                                    'shipment_sku_lot',
                                                                                                                )}

                                                                                                                :
                                                                                                            </label>
                                                                                                            <label className="highlighted-lot">
                                                                                                                {pickLogItem &&
                                                                                                                    pickLogItem.lot}
                                                                                                            </label>
                                                                                                        </div>
                                                                                                        <div className="second-column">
                                                                                                            <label>
                                                                                                                {T(
                                                                                                                    'shipment_pick_expiry_date',
                                                                                                                )}

                                                                                                                :
                                                                                                            </label>
                                                                                                            {pickLogItem &&
                                                                                                                pickLogItem.lotExpirationDate}
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </li>
                                                                                            ),
                                                                                        )}
                                                                                </ul>
                                                                            </div>
                                                                        </li>
                                                                    ),
                                                                )}
                                                        </ui>
                                                    </div>
                                                </div>
                                            ) : null,
                                    )}
                                    <div
                                        className="shrink-area"
                                        id={
                                            pickOrderItem.pickOrderVO
                                                .eoneNumber +
                                            '-' +
                                            pickOrderItem.pickOrderVO.id
                                        }
                                        onClick={() =>
                                            this.expandLessLotHandle(
                                                pickOrderItem.pickOrderVO
                                                    .eoneNumber,
                                                pickOrderItem.pickOrderVO.id,
                                                pickOrderItem.pickOrderVO
                                                    .expandValue,
                                            )
                                        }>
                                        {pickOrderItem.pickOrderVO.expandValue
                                            ? T('shipment_pick_expand_less')
                                            : T('shipment_pick_expand_more')}
                                        {pickOrderItem.pickOrderVO
                                            .expandValue ? (
                                            <ExpandLess />
                                        ) : (
                                            <ExpandMore />
                                        )}
                                    </div>
                                </div>
                            </li>
                        ))}
                </ul>

                <div className="page-bottom-container container-max-width is-fixed no-margin">
                    <div className="all-selected" item xs={3}>
                        <div>
                            <Checkbox
                                checked={checkAll}
                                onChange={this.handleAllCheck.bind(this)}
                            />
                        </div>
                        <label>{T('shipment_pick_all')}</label>
                    </div>
                    <div className="pick-list-btn-container">
                        <BasicButton
                            type="info"
                            className="cancel-pick-infor"
                            onClickOfSingleTap={this.deletePickOrdersHandle}
                            isStopPropagation={true}>
                            {T('shipment_pick_delete')}
                        </BasicButton>
                        <BasicButton
                            type="primary"
                            className="preview-pick-infor"
                            onClickOfSingleTap={this.pickOrderPreviewHandle}
                            isStopPropagation={true}>
                            {T('shipment_pick_list')}
                        </BasicButton>
                        <BasicButton
                            type="primary"
                            className="recommended-pick-infor"
                            onClickOfSingleTap={this.recommendedProductHandle}
                            isStopPropagation={true}>
                            {T('shippment_recommended_list')}
                        </BasicButton>
                        <BasicButton
                            type="primary"
                            className="delivery-pick-infor"
                            onClickOfSingleTap={this.shipOrderHandle}
                            isStopPropagation={true}>
                            {T('shippment_delivery_order')}
                        </BasicButton>
                    </div>
                </div>

                <Dialog
                    opened={confirmCancelPickOrderDialog}
                    dialogDidClose={() =>
                        this.dialogDidClose('confirmCancelPickOrderDialog')
                    }
                    options={{bgClickClose: true}}>
                    <div className="cancel-pick-order-dialog">
                        <h5 className="cancel-pick-order-dialog-title text-center">
                            {T('shipment_pick_confirm_delete_pick_order')}
                        </h5>
                        <p className="cancel-pick-order-dialog-desc text-center">
                            {T('shipment_pick_is_confirm_delete_pick_order')}
                        </p>
                        <div className="cancel-pick-order-btn-container">
                            <BasicButton
                                type="primary"
                                className="cancel-pick-order-confirm-btn"
                                onClickOfSingleTap={this.cancelPickOrderHandle}>
                                {T('order_confirm')}
                            </BasicButton>
                            <BasicButton
                                type="primary"
                                className="cancel-confirm-btn"
                                onClickOfSingleTap={() =>
                                    this.dialogDidClose(
                                        'confirmCancelPickOrderDialog',
                                    )
                                }>
                                {T('cancel')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>

                <Dialog
                    opened={confirmBatchShipmentOrderDialog}
                    dialogDidClose={() =>
                        this.dialogDidClose('confirmBatchShipmentOrderDialog')
                    }
                    options={{bgClickClose: true}}>
                    <div className="cancel-pick-order-dialog">
                        <h5 className="cancel-pick-order-dialog-title text-center">
                            {T('shipment_pick_batch_delivery')}
                        </h5>
                        <p className="cancel-pick-order-dialog-desc text-center">
                            {T('shipment_pick_confirm_batch_delivery')}
                        </p>
                        <div className="cancel-pick-order-btn-container">
                            <BasicButton
                                type="primary"
                                className="cancel-pick-order-confirm-btn"
                                onClickOfSingleTap={
                                    this.confirmBatchShipmentOrderHandle
                                }>
                                {T('order_confirm')}
                            </BasicButton>
                            <BasicButton
                                type="primary"
                                className="cancel-confirm-btn"
                                onClickOfSingleTap={() =>
                                    this.dialogDidClose(
                                        'confirmBatchShipmentOrderDialog',
                                    )
                                }>
                                {T('cancel')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>

                <Dialog
                    opened={confirmRecommendedProductDialog}
                    dialogDidClose={() =>
                        this.dialogDidClose('confirmRecommendedProductDialog')
                    }
                    options={{bgClickClose: true}}>
                    <div className="recommended-product-dialog">
                        <h5 className="recommended-product-dialog-title text-center">
                            {T('shipment_pick_batch_recommended_product')}
                        </h5>
                        <p className="recommended-product-dialog-desc text-center">
                            {T(
                                'shipment_pick_confirm_batch_recommended_product',
                            )}
                        </p>
                        <div className="recommended-product-btn-container">
                            <BasicButton
                                type="primary"
                                className="cancel-pick-order-confirm-btn"
                                onClickOfSingleTap={
                                    this.confirmBatchRecommendedProductHandle
                                }>
                                {T('order_confirm')}
                            </BasicButton>
                            <BasicButton
                                type="primary"
                                className="cancel-confirm-btn"
                                onClickOfSingleTap={() =>
                                    this.dialogDidClose(
                                        'confirmRecommendedProductDialog',
                                    )
                                }>
                                {T('cancel')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>

                <Dialog
                    opened={confirmPickOrderPreviewDialog}
                    dialogDidClose={() =>
                        this.dialogDidClose('confirmPickOrderPreviewDialog')
                    }
                    options={{bgClickClose: true}}>
                    <div className="recommended-product-dialog">
                        <h5 className="recommended-product-dialog-title text-center">
                            {T(
                                'shipment_pick_confirm_batch_pick_order_preview',
                            )}
                        </h5>
                        <p className="recommended-product-dialog-desc text-center">
                            {T('shipment_pick_confirm_batch_pick_order_pdf')}
                        </p>
                        <div className="recommended-product-btn-container">
                            <BasicButton
                                type="primary"
                                className="cancel-pick-order-confirm-btn"
                                onClickOfSingleTap={
                                    this.confirmBatchPrintPickOrderHandle
                                }>
                                {T('order_confirm')}
                            </BasicButton>
                            <BasicButton
                                type="primary"
                                className="cancel-confirm-btn"
                                onClickOfSingleTap={() =>
                                    this.dialogDidClose(
                                        'confirmPickOrderPreviewDialog',
                                    )
                                }>
                                {T('cancel')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>

                <Dialog opened={orderMessageListDialog}>
                    <div className="message-list-dialog">
                        <h5 className="message-list-dialog-title text-center">
                            {T('shipment_pick_message_list_title')}
                        </h5>
                        <p className="message-list-content-container text-center">
                            <div className="order-num">
                                <div className="message-eone-number">
                                    {T('order_eone_number')}: {currentEoneNum}
                                </div>
                                <div className="message-count">
                                    {T('shipment_pick_message_count', [
                                        currentOrderIdMessageList.length,
                                    ])}
                                </div>
                            </div>
                            {currentOrderIdMessageList.length > 0 &&
                                currentOrderIdMessageList.map((messageItem) => (
                                    <div className="message-list-container">
                                        <div className="from-to-user-container">
                                            <div className="from-to-user">
                                                <div className="message-left">
                                                    {messageItem.fromUserName !==
                                                    '系统提示'
                                                        ? T(
                                                              'host_message_list_admin',
                                                          )
                                                        : ''}{' '}
                                                    {messageItem.fromUserName}{' '}
                                                </div>
                                                {T(
                                                    'host_message_list_to_user_name',
                                                )}
                                                <div className="message-right">
                                                    {messageItem.toUserNameList
                                                        .length > 0
                                                        ? messageItem.toUserNameList.join(
                                                              '，',
                                                          )
                                                        : ''}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="message-content">
                                            <div className="content-value">
                                                {messageItem.content}
                                            </div>
                                        </div>
                                        <div className="message-time">
                                            <div className="time-value">
                                                {messageItem.createTime}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                        </p>
                        <div className="message-btn-container">
                            <BasicButton
                                type="primary"
                                className="cancel-pick-order-confirm-btn"
                                onClickOfSingleTap={
                                    this.onKeyReadMessageHandle
                                }>
                                {T('btn_action_ok')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>

                <Dialog
                    opened={completedShippingPlanDialog}
                    dialogDidClose={() =>
                        this.dialogDidClose('completedShippingPlanDialog')
                    }
                    options={{bgClickClose: true}}>
                    <div className="preview-pick-order-dialog">
                        <h3 className="preview-pick-order-dialog-title text-center">
                            {T('shipping_plan_complete_confirm_message')}
                        </h3>

                        <div className="preview-pick-order-btn-container">
                            <BasicButton
                                type="primary"
                                className="preview-pick-order-confirm-btn complete-shipping-plan-confirm-btn"
                                onClickOfSingleTap={
                                    this.completedShippingPlanEvent
                                }>
                                {T('order_confirm')}
                            </BasicButton>
                            <BasicButton
                                type="primary"
                                className="cancel-confirm-btn complete-shipping-plan-cancel-btn"
                                onClickOfSingleTap={() =>
                                    this.dialogDidClose(
                                        'completedShippingPlanDialog',
                                    )
                                }>
                                {T('cancel')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {host, localData} = state;
    return {
        myOrderPickDetails: host.myOrderPickDetails,
        batchShipmentData: host.batchShipmentData,
        batchRecommendProductData: host.batchRecommendProductData,
        batchPrintPickOrderData: host.batchPrintPickOrderData,
        pickOrderMessageList: host.pickOrderMessageList,
    };
};

const mapDispatchToProps = {
    openNotification,
    queryPickOrderList,
    cancelPickOrder,
    shipOrder,
    createInvoiceMorePdf,
    previewBatchShipmentPdf,
    batchRecommendProductPdf,
    batchPickOrderPreviewPdf,
    getPickOrderMessageList,
    oneKeyReadMessage,

    completeShippingPlan,
};

export default connect(mapStateToProps, mapDispatchToProps)(MyOrderPick);
